import React from 'react'
import { bewizrStore } from '~/stores'
import { observer } from '~/ui/component'
import { HBox, Label, SVG, Tappable } from '~/ui/components'
import { createUseStyles, layout } from '~/ui/styling'

export interface Props {
}

const BeWizrOrganizationSwitcher = observer('BeWizrOrganizationSwitcher', (props: Props) => {
  const {profile} = bewizrStore
  const currentOrganization    = profile?.organization
  const availableOrganizations = profile?.availableOrganizations ?? []

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    if (currentOrganization == null || availableOrganizations.length < 2) { return null }

    return (
      <>
        <Tappable classNames={$.BeWizrOrganizationSwitcher} href='/oauth/bewizr/switch-project' behaviour='native'>
          <HBox gap={layout.padding.inline.m}>
            <SVG size={layout.icon.s} name='organization'/>
            <Label flex small bold>{currentOrganization.title}</Label>
            <SVG dim name='chevron-down' size={layout.icon.xs}/>
          </HBox>
        </Tappable>
      </>

    )
  }

  return render()
})

export default BeWizrOrganizationSwitcher

const useStyles = createUseStyles(theme => ({
  BeWizrOrganizationSwitcher: {
    border: [1, 'solid', theme.border.dimmer],
    borderRadius: layout.radius.l,
    padding: layout.padding.inline.m,
  },
}))